<template>
	<TopTab style="background: #FFAA96; position: relative;" />
	<div class="collection-container">
		<div class="collection-inner">
			<div class="search-bar">
				<van-search v-model="searchText" placeholder="请输入产品名称、标签、类型、发布者等其他关键词搜索您需要的内容" shape="round"
					background="#F6F6F6" @search="onSearchClick" />
			</div>
			<div class="category-tabs">
				<van-swipe class="my-swipe" :show-indicators="true" :autoplay="false">
					<van-swipe-item v-for="item in categoryList">
						<ul>
							<!-- <li v-for="sub in item" :style="{ active: sub.id === activeCategory }" @click="onCategoryChange(sub.id)"> -->
							<li v-for="sub in item" :style="{ active: sub.id === activeCategory }" @click="router.push({ path: '/collection-list', query: { id: sub.id } })">
								<img :src="sub.picUrl" />
								<p>{{ sub.name }}</p>
							</li>
						</ul>
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<div class="list_wrap">
			<van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="loadData" offset="100">
				<div class="waterfall-grid">
					<div class="waterfall-column" v-for="(column, index) in columns" :key="index">
						<div class="waterfall-item" v-for="item in column" :key="item.id" @click="jumpToDetail(item)">
							<AssetsCard :item="item" />
						</div>
					</div>
				</div>
			</van-list>
		</div>
		<van-empty v-if="list.length === 0 && !loading" description="暂无数据" />
		<FooterBar />
	</div>
	
</template>

<script setup>
import TopTab from '@/views/front/components/TopTab.vue'
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { http } from '@/request/front'
import AssetsCard from '@/views/front/components/AssetsCard.vue'
import img1 from '@/assets/imgs/img1.png'
import FooterBar from '@/views/front/components/FooterBar.vue'

const router = useRouter()
const searchText = ref('')
const activeCategory = ref('')
const list = ref([])
const loading = ref(false)

const columnCount = 2

const columns = computed(() => {
	const cols = Array.from({ length: columnCount }, () => [])
	list.value.forEach((item, index) => {
		cols[index % columnCount].push(item)
	})
	return cols
})

function onSearchClick() {
	console.log('search:', searchText.value)
	pageNo.value = 1
	list.value = []
	finished.value = false
	loadData()
}

function onCategoryChange(categoryId) {
	activeCategory.value = categoryId
	pageNo.value = 1
	list.value = []
	finished.value = false
	loadData()
}
const pageNo = ref(1)
const pageSize = 12
const finished = ref(false)

async function loadData() {
	loading.value = true
	http.get(`https://www.bolanzg.com/app-api/product/spu/page?name=${searchText.value}&pageNo=${pageNo.value}&pageSize=${pageSize}&categoryId=${activeCategory.value}&modelFormat=&period=&isAnimation=&isMaterial=&isChartlet=&isModel=&isWorks=&isFree=&isCommercial=&priceRange=&sortField=createTime&sortAsc=false&type=1`).then(res => {
		loading.value = false
		pageNo.value++
		list.value.push(...res.data.data.list)
		finished.value = res.data.data.total <= list.value.length
	})

}
const categoryList = ref([])
function fetchCategory() {
	http.get('https://www.bolanzg.com/app-api/product/category/treeList').then(res => {
		// categoryList.value = res.data.data
		const list = res.data.data
		list.unshift({
			id: '',
			name: '全部',
			picUrl: img1,
		})
		for (let i = 0; i < Math.ceil(list.length / 10); i++) {
			categoryList.value.push(list.slice(i * 10, (i + 1) * 10))
		}
	})
}

function jumpToDetail(item) {
	router.replace({ path: '/assets-detail', query: { id: item.id } })
	window.scrollTo(0, 0)
}

onMounted(() => {
	loadData()
	fetchCategory()
})
</script>

<style scoped lang="scss">
.collection-container {
	min-height: 100vh;
	background-color: #F6F6F6;
	.collection-inner {
		padding: 15rem 15rem 200rem 15rem;
		background: linear-gradient(180deg, #FFAA96 0%, #F6F6F6 400px);
	}
}

.search-bar {
	margin: 12rem 0;

	::v-deep(.van-search) {
		border-radius: 16rem;
		height: 32rem;

		.van-search__field {
			height: 32rem;

			.van-field__control {
				font-size: 12rem;
			}
		}
	}
}

.category-tabs {
	height: 186rem;
	padding: 10rem;
	background: #F6F6F6;
	border-radius: 10rem;

	.my-swipe {
		ul {
			display: flex;
			align-items: center;
			flex-wrap: wrap;

			li {
				width: 20%;
				margin: 5rem 0;
				display: flex;
				flex-direction: column;
				align-items: center;

				img {
					width: 50rem;
					height: 50rem;
					object-fit: cover;
					border-radius: 50%;
					background: linear-gradient(180deg, rgba(204, 204, 204, 0) 0%, rgba(204, 204, 204, 1) 100%);
				}

				p {
					font-size: 12rem;
					color: #5C5C5C;
				}
			}
		}
	}
}

.list_wrap{
	position: relative; top: -190rem;
}
.waterfall-grid {
	display: flex;
	padding: 15rem;
	gap: 15rem;

	.waterfall-column {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.waterfall-item {
		background: #fff;
		overflow: hidden;

		img {
			width: 100%;
			display: block;
		}

		.item-info {
			padding: 10px;

			h6 {
				font-size: 14px;
				margin: 0 0 8px 0;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.item-stats {
				display: flex;
				gap: 12px;
				font-size: 12px;
				color: #999;

				span {
					display: flex;
					align-items: center;
					gap: 4px;
				}
			}
		}
	}
}

.loading {
	text-align: center;
	padding: 20px;
}
</style>
